var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGridIcon = function SvgGridIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    className: "svgr-icon"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M2 2v2h2v2h2v2h2v2h2v2h2v-2h2V8h2V6h2V4h2V2h2v20h-2v-2h-2v-2h-2v-2h-2v-2h-2v2h-2v2H8v2H6v2H4v-2H2zm2 2v2h2V4zm4 4v2h2V8zm6 0v2h2V8zm4-4v2h2V4zM4 18v2h2v-2zm14 0v2h2v-2z"
  })));
};
export default SvgGridIcon;